import { render } from "./TheCartOils.vue?vue&type=template&id=453e2241"
import script from "./TheCartOils.vue?vue&type=script&lang=js"
export * from "./TheCartOils.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__